// Gestion des liens dans le cadre "Nos Atouts" de la page "nous rejoindre"
for( var i=1; i<4; i++){

    $('#component2-link'+i).click(function(){

        var clickedId = this.id.slice(-1);

        for( var j=1; j<4; j++){

            if(clickedId == j){
                // Activation du lien cliqué et du cadre d'information correspondant
                if(!$('#component2-link'+j).hasClass('active')){
                    $('#component2-link'+j).addClass("active");
                }
                if(!$('#frame25-block'+j).hasClass('active')){
                    $('#frame25-block'+j).addClass("active");
                }
            }
            else{
                // Désactivation des autres liens et des cadres d'information correspondants
                if($('#component2-link'+j).hasClass('active')){
                    $('#component2-link'+j).removeClass("active");
                }
                if($('#frame25-block'+j).hasClass('active')){
                    $('#frame25-block'+j).removeClass("active");
                }
            }
        }
    });
}
